import { v4 as uuidv4 } from 'uuid';

export interface DeepIsEmptyOptions {
  emptyStringIsEmpty?: boolean;
  zeroIsEmpty?: boolean;
}

export class CommonHelper {
  static deepIsEmpty(value: any, options: DeepIsEmptyOptions = {}, seen: WeakSet<any> = new WeakSet()): boolean {
    const { emptyStringIsEmpty = false, zeroIsEmpty = false } = options;

    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === 'string') {
      return emptyStringIsEmpty ? value.trim().length === 0 : false;
    }

    if (typeof value === 'number') {
      return zeroIsEmpty ? value === 0 : false;
    }

    if (value instanceof Date) {
      return isNaN(value.getTime());
    }

    if (typeof value !== 'object') {
      return false;
    }

    if (seen.has(value)) {
      return true;
    }
    seen.add(value);

    if (Array.isArray(value)) {
      return value.length === 0 || value.every(item => this.deepIsEmpty(item, options, seen));
    }

    const keys = Object.keys(value);
    if (keys.length === 0) {
      return true;
    }

    return keys.every(key => this.deepIsEmpty(value[key], options, seen));
  }

  static isEqual(value1: unknown, value2: unknown): boolean {
    return JSON.stringify(value1) === JSON.stringify(value2);
  }

  static generateTempUuid(): string {
    return uuidv4();
  }
}
